<template>
  <div class="dashboard-container">
    <div class="dashboard-content">
      <div class="dashboard-header">
        <h2>仪表盘</h2>
        <p>系统概览</p>
      </div>
      
      <!-- 统计卡片 -->
      <div class="stats-cards">
        <div class="stat-card" v-for="(card, index) in statCards" :key="index">
          <div class="card-bg"></div>
          <div class="stat-icon" :class="card.iconClass">
            <i :class="card.icon"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ card.value }}</div>
            <div class="stat-label">{{ card.label }}</div>
            <div class="stat-sub">{{ card.sub }}</div>
          </div>
          <div class="card-glow"></div>
        </div>
      </div>
      
      <!-- 今日生成统计 -->
      <div class="today-stats">
        <div class="section-title">
          <div class="title-line"></div>
          <span>今日生成统计</span>
          <div class="title-line"></div>
        </div>
        <div class="today-grid">
          <div class="today-item" v-for="(item, i) in todayStats" :key="i">
            <div class="item-icon" :style="{background: item.color}">
              <i :class="item.icon"></i>
            </div>
            <div class="item-info">
              <div class="item-value">{{ item.value }}</div>
              <div class="item-label">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 图表区域 -->
      <div class="charts-container">
        <div class="chart-card">
          <div class="card-header">
            <div class="header-dot"></div>
            <h3>用户注册趋势</h3>
          </div>
          <div id="userChart" class="chart"></div>
        </div>
        <div class="chart-card">
          <div class="card-header">
            <div class="header-dot"></div>
            <h3>模型使用情况</h3>
          </div>
          <div id="modelChart" class="chart"></div>
        </div>
        <div class="chart-card">
          <div class="card-header">
            <div class="header-dot"></div>
            <h3>订单趋势</h3>
          </div>
          <div id="orderChart" class="chart"></div>
        </div>
        <div class="chart-card">
          <div class="card-header">
            <div class="header-dot"></div>
            <h3>生成类型分布</h3>
          </div>
          <div id="revenueChart" class="chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'Dashboard',
  data() {
    return {
      stats: {
        totalUsers: 128,
        todayUsers: 5,
        totalOrders: 86,
        todayOrders: 3,
        totalRevenue: 2580.00,
        todayRevenue: 199.00,
        todayImages: 45,
        todayVideos: 12,
        todayTexts: 38,
        totalImages: 1256,
        totalVideos: 432,
        totalTexts: 2890,
        userTrend: [
          { date: '05-05', count: 8 },
          { date: '05-06', count: 12 },
          { date: '05-07', count: 6 },
          { date: '05-08', count: 15 },
          { date: '05-09', count: 10 },
          { date: '05-10', count: 18 },
          { date: '05-11', count: 5 }
        ],
        imageModels: [
          { model: 'wanx-v1', count: 520 },
          { model: 'midjourney-v6', count: 380 },
          { model: 'stable-diffusion', count: 256 },
          { model: 'dalle-3', count: 100 }
        ],
        videoModels: [
          { model: 'wan2.7-t2v', count: 180 },
          { model: 'wan2.7-i2v', count: 152 },
          { model: 'd-id-free', count: 100 }
        ],
        orderTrend: [
          { date: '05-05', count: 5, revenue: 299 },
          { date: '05-06', count: 8, revenue: 498 },
          { date: '05-07', count: 3, revenue: 99 },
          { date: '05-08', count: 12, revenue: 796 },
          { date: '05-09', count: 7, revenue: 398 },
          { date: '05-10', count: 15, revenue: 990 },
          { date: '05-11', count: 3, revenue: 199 }
        ],
        generationTypes: [
          { name: '图片生成', value: 1256 },
          { name: '视频生成', value: 432 },
          { name: '文案生成', value: 2890 }
        ]
      },
      loading: false,
      userChart: null,
      modelChart: null,
      orderChart: null,
      revenueChart: null
    }
  },
  computed: {
    statCards() {
      if (!this.stats) return []
      return [
        {
          icon: 'el-icon-user',
          iconClass: 'users',
          value: this.stats.totalUsers || 0,
          label: '总用户数',
          sub: `今日 +${this.stats.todayUsers || 0}`
        },
        {
          icon: 'el-icon-document',
          iconClass: 'orders',
          value: this.stats.todayOrders || 0,
          label: '今日订单',
          sub: `总计 ${this.stats.totalOrders || 0}`
        },
        {
          icon: 'el-icon-s-finance',
          iconClass: 'revenue',
          value: `¥${(this.stats.totalRevenue || 0).toFixed(2)}`,
          label: '总收入',
          sub: `今日 ¥${(this.stats.todayRevenue || 0).toFixed(2)}`
        },
        {
          icon: 'el-icon-data-analysis',
          iconClass: 'generation',
          value: (this.stats.totalImages || 0) + (this.stats.totalVideos || 0) + (this.stats.totalTexts || 0),
          label: '总生成数',
          sub: `今日 ${this.stats.todayImages || 0}+${this.stats.todayVideos || 0}+${this.stats.todayTexts || 0}`
        }
      ]
    },
    todayStats() {
      if (!this.stats) return []
      return [
        { icon: 'el-icon-picture', label: '图片生成', value: this.stats.todayImages || 0, color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
        { icon: 'el-icon-video-camera', label: '视频生成', value: this.stats.todayVideos || 0, color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
        { icon: 'el-icon-edit', label: '文案生成', value: this.stats.todayTexts || 0, color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }
      ]
    }
  },
  mounted() {
    this.fetchStats()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.userChart) this.userChart.dispose()
    if (this.modelChart) this.modelChart.dispose()
    if (this.orderChart) this.orderChart.dispose()
    if (this.revenueChart) this.revenueChart.dispose()
  },
  methods: {
    async fetchStats() {
      try {
        const res = await this.$axios.get('/admin/dashboard/stats')
        console.log('Dashboard API response:', res.data)
        if (res.data.code === 200) {
          const data = res.data.data
          // 合并真实数据到模拟数据
          Object.keys(data).forEach(key => {
            if (data[key] !== null && data[key] !== undefined) {
              this.stats[key] = data[key]
            }
          })
          this.$nextTick(() => {
            this.initCharts()
          })
        }
      } catch (err) {
        console.log('API 请求失败，使用模拟数据')
      }
      // 无论 API 成功失败，都初始化图表
      this.$nextTick(() => {
        this.initCharts()
      })
    },
    initCharts() {
      if (!this.stats) return
      this.$nextTick(() => {
        this.initUserChart()
        this.initModelChart()
        this.initOrderChart()
        this.initRevenueChart()
      })
    },
    initUserChart() {
      const chart = echarts.init(document.getElementById('userChart'))
      this.userChart = chart
      const trend = this.stats.userTrend || []
      chart.setOption({
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(20,25,40,0.9)', borderColor: '#00e6ac', textStyle: { color: '#fff' } },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '10%', containLabel: true },
        xAxis: { type: 'category', data: trend.map(t => t.date), axisLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } }, axisLabel: { color: '#888' } },
        yAxis: { type: 'value', splitLine: { lineStyle: { color: 'rgba(255,255,255,0.05)' } }, axisLabel: { color: '#888' } },
        series: [{
          data: trend.map(t => t.count),
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: { width: 3, color: '#00e6ac' },
          itemStyle: { color: '#00e6ac' },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0,230,172,0.3)' },
              { offset: 1, color: 'rgba(0,230,172,0)' }
            ])
          }
        }]
      })
    },
    initModelChart() {
      const chart = echarts.init(document.getElementById('modelChart'))
      this.modelChart = chart
      const models = [...(this.stats.imageModels || []), ...(this.stats.videoModels || [])].slice(0, 5)
      chart.setOption({
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(20,25,40,0.9)', borderColor: '#00e6ac', textStyle: { color: '#fff' } },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '10%', containLabel: true },
        xAxis: { type: 'category', data: models.map(m => m.model), axisLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } }, axisLabel: { color: '#888', rotate: 30 } },
        yAxis: { type: 'value', splitLine: { lineStyle: { color: 'rgba(255,255,255,0.05)' } }, axisLabel: { color: '#888' } },
        series: [{
          data: models.map(m => m.count),
          type: 'bar',
          barWidth: '40%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00e6ac' },
              { offset: 1, color: 'rgba(0,230,172,0.2)' }
            ]),
            borderRadius: [4, 4, 0, 0]
          }
        }]
      })
    },
    initOrderChart() {
      const chart = echarts.init(document.getElementById('orderChart'))
      this.orderChart = chart
      const trend = this.stats.orderTrend || []
      chart.setOption({
        tooltip: { trigger: 'axis', backgroundColor: 'rgba(20,25,40,0.9)', borderColor: '#00e6ac', textStyle: { color: '#fff' } },
        legend: { data: ['订单数', '收入'], textStyle: { color: '#888' }, top: 0 },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
        xAxis: { type: 'category', data: trend.map(t => t.date), axisLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } }, axisLabel: { color: '#888' } },
        yAxis: [
          { type: 'value', splitLine: { lineStyle: { color: 'rgba(255,255,255,0.05)' } }, axisLabel: { color: '#888' } },
          { type: 'value', splitLine: { show: false }, axisLabel: { color: '#888', formatter: '¥{value}' } }
        ],
        series: [
          {
            name: '订单数', data: trend.map(t => t.count), type: 'line', smooth: true,
            lineStyle: { width: 3, color: '#4facfe' }, itemStyle: { color: '#4facfe' },
            areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(79,172,254,0.3)' }, { offset: 1, color: 'rgba(79,172,254,0)' }]) }
          },
          {
            name: '收入', data: trend.map(t => t.revenue), type: 'bar', yAxisIndex: 1, barWidth: '30%',
            itemStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#f5576c' }, { offset: 1, color: 'rgba(245,87,108,0.2)' }]), borderRadius: [4, 4, 0, 0] }
          }
        ]
      })
    },
    initRevenueChart() {
      const chart = echarts.init(document.getElementById('revenueChart'))
      this.revenueChart = chart
      const types = this.stats.generationTypes || []
      chart.setOption({
        tooltip: { trigger: 'item', backgroundColor: 'rgba(20,25,40,0.9)', borderColor: '#00e6ac', textStyle: { color: '#fff' } },
        series: [{
          type: 'pie',
          radius: ['45%', '70%'],
          center: ['50%', '55%'],
          avoidLabelOverlap: false,
          label: { show: true, formatter: '{b}: {c}', color: '#ccc', fontSize: 13 },
          labelLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } },
          data: [
            { value: types.find(t => t.name === '图片生成')?.value || 0, name: '图片生成', itemStyle: { color: '#00e6ac' } },
            { value: types.find(t => t.name === '视频生成')?.value || 0, name: '视频生成', itemStyle: { color: '#4facfe' } },
            { value: types.find(t => t.name === '文案生成')?.value || 0, name: '文案生成', itemStyle: { color: '#f5576c' } }
          ]
        }]
      })
    },
    handleResize() {
      if (this.userChart) this.userChart.resize()
      if (this.modelChart) this.modelChart.resize()
      if (this.orderChart) this.orderChart.resize()
      if (this.revenueChart) this.revenueChart.resize()
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px 0;
  background: linear-gradient(180deg, #0a0e1a 0%, #0f1525 100%);
  min-height: 100vh;
}

.dashboard-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.dashboard-header {
  margin-bottom: 30px;
  position: relative;
}

.dashboard-header h2 {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(90deg, #00e6ac, #4facfe);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0 0 8px 0;
}

.dashboard-header p {
  font-size: 14px;
  color: rgba(255,255,255,0.4);
  margin: 0;
}

/* 统计卡片 */
.stats-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  position: relative;
  background: linear-gradient(135deg, rgba(20,25,40,0.9) 0%, rgba(15,20,35,0.9) 100%);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-4px);
  border-color: rgba(0,230,172,0.3);
  box-shadow: 0 8px 32px rgba(0,230,172,0.1);
}

.card-bg {
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(0,230,172,0.05) 0%, transparent 70%);
  pointer-events: none;
}

.card-glow {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00e6ac, transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.stat-card:hover .card-glow {
  opacity: 1;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #fff;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.stat-icon::before {
  content: '';
  position: absolute;
  inset: -1px;
  border-radius: 14px;
  padding: 1px;
  background: linear-gradient(135deg, rgba(255,255,255,0.2), transparent);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}

.stat-icon.users { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.stat-icon.orders { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); }
.stat-icon.revenue { background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); }
.stat-icon.generation { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }

.stat-content {
  position: relative;
  z-index: 1;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}

.stat-label {
  font-size: 13px;
  color: rgba(255,255,255,0.5);
  margin-top: 4px;
}

.stat-sub {
  font-size: 12px;
  color: #00e6ac;
  margin-top: 6px;
  background: rgba(0,230,172,0.1);
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
}

/* 今日生成统计 */
.today-stats {
  background: linear-gradient(135deg, rgba(20,25,40,0.9) 0%, rgba(15,20,35,0.9) 100%);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 30px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.title-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
}

.today-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.today-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: rgba(255,255,255,0.03);
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.05);
  transition: all 0.3s ease;
}

.today-item:hover {
  background: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.1);
}

.item-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #fff;
  flex-shrink: 0;
}

.item-info {
  flex: 1;
}

.item-value {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

.item-label {
  font-size: 13px;
  color: rgba(255,255,255,0.5);
  margin-top: 4px;
}

/* 图表区域 */
.charts-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.chart-card {
  background: linear-gradient(135deg, rgba(20,25,40,0.9) 0%, rgba(15,20,35,0.9) 100%);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s ease;
}

.chart-card:hover {
  border-color: rgba(0,230,172,0.2);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.header-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00e6ac;
  box-shadow: 0 0 10px rgba(0,230,172,0.5);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.chart-card h3 {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

.chart {
  height: 300px;
}

/* 响应式 */
@media (max-width: 1024px) {
  .stats-cards { grid-template-columns: repeat(2, 1fr); }
  .charts-container { grid-template-columns: 1fr; }
  .today-grid { grid-template-columns: 1fr; }
}

@media (max-width: 768px) {
  .stats-cards { grid-template-columns: 1fr; }
}
</style>
